<template>
	<div class="nqt-container ">
		<v-layout row justify-space-between
			:style="`border-bottom:1px solid ${$appColors.gray}`">
			<h2
				class="nqt-container-title"
				:style="`color:${$appColors.primary}; text-transform: uppercase;`"
			>{{ employee.employee.name }} {{ employee.employee.lastName }}</h2>
			<h2 class="nqt-container-title"
				:style="`color:${$appColors.secondary};`"
			> {{ evaluatorSelected.length }} / {{ employees.length }} </h2>
		</v-layout>
		<v-layout row justify-space-between tw-mt-3>
			<v-flex xs8></v-flex>
			<v-flex xs4>
				<button-clear
					value="Filtros"
					@click="openModalGroup">
				</button-clear>
			</v-flex>
		</v-layout>
				<div class="tags-container tw-mt-3">
					<div class="tag"
						v-for="(name, index) in formattedSelectedNames" :key="index"
						:style="`border: 1px solid ${$appColors.primary}; color: ${$appColors.primary}; background-color: #D3FCC5`">
						<div class="tag-content">{{ name }}
							<v-icon @click="removeItem(index)">close</v-icon>
						</div>
					</div>
				</div>
		<app-table
			class="no-main-list"
			:columns="columns"
			:filter-columns="false"
			:main-list="true"
			:rows="employees"
			:total-items="totalItems"
			:last-page="lastPage"
			:current-page="currentPage"
			:items-quantity="7"
			:items-total-quantity="totalItems"
			:check-all="checkAll"
			selectable
			@on-search-event="onSearchEvent"
			@on-page="changePage"
			@row-is-selected="rowIsSelected"
			@on-selected-all="selectedAll"
			@changeSort="changeSort"
			@changeColor="changeColor">
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)">
						<h3 >{{ props.row.name }} {{ props.row.lastName }}</h3>
						<p :style="` color:${$appColors.secondary}; font-size: 10px;`">{{ props.row.group.name }}</p>
				</td>
				<td v-show="showRow(columns, 2)" @click.stop="stopClick" >
					<v-select
						v-if="props.row.isSelected"
						class="select-core"
						hide-details
						clearable
						height="17"
						outline
						single-line
						:items="referenceGroups"
						item-value="id"
						item-text="name"
						:value="props.row.referenceGroup"
						@change="selectReferencedGroup({ emplID: props.row.id, value: $event })"
						return-object>
					</v-select>
				</td>
			</template>
		</app-table>
		<modal-action
			:color="color"
			:dialog="openModal"
			title="Filtro"
			@close-modal="closeModal"
			@create-employee="filterAreas">
			<v-layout row>
				<v-flex xs12>
					<label :style="`color:${$appColors.info}`">Área
						<v-select
							class="select-core"
							height="37"
							hide-details
							label="Áreas"
							outline
							multiple
							chips
							single-line
							:items="groups"
							item-value="id"
							item-text="name"
							:menu-props="{ contentClass: 'type-select-content' }"
							@input="filterRows($event, 'groupIds')"
						></v-select>
					</label>
				</v-flex>
			</v-layout>
		</modal-action>
	</div>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';
import buttonClear from '@/components/configuration/button-clear';
import modalAction from '@/components/evaluations/modal-action';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { getLocalData } = helper;

function mounted() {
	this.loadEmployees();
	const refGroup = this.$store.state.evaluation360.process;
	const processData = getLocalData('process');
	if (refGroup === null) {
		this.$store.dispatch('evaluation360/assignProcess', processData);
	}
}

function created() {
	this.evaluatorSelected = this.employees.filter(f => f.isSelected);
	this.loadGroups();
	this.loadEmployees();
}

async function loadEmployees() {
	try {
		const params = {
			...this.params,
			groupIds: this.paramsGroup.groupIds,
			search: this.paramsGroup.search,
		};
		if (this.paramsGroup.search || this.paramsGroup.groupIds) {
			const { data: response, headers } = await this.$httpPraktiko.get('employee', { params });
			this.employees = response.results;
			this.employees = this.employees.filter(emp => emp.id !== this.employee.employee.id);
			this.employees = this.employees.map((emploForeval) => {
				const newEmploForEval = { ...emploForeval };
				newEmploForEval.isSelected = false;
				newEmploForEval.referenceGroup = null;
				this.employee.evaluators.employees.forEach((employSel) => {
					if (emploForeval.id === employSel.id) {
						newEmploForEval.isSelected = employSel.isSelected;
						newEmploForEval.referenceGroup = employSel.referenceGroup;
						newEmploForEval.status = employSel.status;
					}
				});
				return newEmploForEval;
			});

			const empl = this.employees.filter(f => f.isSelected);
			const fltEmp = empl.filter(itemB => !this.evaluatorSelected
				.some(itemA => itemA.id === itemB.id));
			this.lastPage = Number(headers['x-last-page']);
			this.totalItems = Number(headers['x-quantity']);
			this.evaluatorSelected = this.evaluatorSelected.concat(fltEmp);
		} else {
			const { data: response, headers } = await this.$httpPraktiko.get('employee', { params });
			this.employees = response.results;
			this.employees = this.employees.filter(emp => emp.id !== this.employee.employee.id);
			this.employees = this.employees.map((emploForeval) => {
				const newEmploForEval = { ...emploForeval };
				newEmploForEval.isSelected = false;
				newEmploForEval.referenceGroup = null;
				this.employee.evaluators.employees.forEach((employSel) => {
					if (emploForeval.id === employSel.id) {
						newEmploForEval.isSelected = employSel.isSelected;
						newEmploForEval.referenceGroup = employSel.referenceGroup;
						newEmploForEval.status = employSel.status;
					}
				});
				return newEmploForEval;
			});
			this.lastPage = Number(headers['x-last-page']);
			this.totalItems = Number(headers['x-quantity']);
			this.evaluatorSelected = this.employees.filter(f => f.isSelected);
		}
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		}
	}
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadEmployees();
}

function changeSort({ fieldName, sortDirection }) {
	this.params.sortField = fieldName;
	this.params.sortDirection = sortDirection;
	this.loadEmployees();
}

async function loadGroups() {
	try {
		({ data: this.groups } = await this.$httpPraktiko.get('groups'));
		this.employees = this.employees.map((g) => {
			const newEmployees = { ...g };
			newEmployees.isSelected = false;
			return newEmployees;
		});
		this.employees = this.employees.filter(emp => emp.id !== this.employee.employee.id);
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		}
	}
}

function onSearchEvent(search) {
	this.paramsGroup.search = search.trim() || null;
	this.loadEmployees();
}

function rowIsSelected(value) {
	const val = value;
	if (val.isSelected) {
		// No sobrescribir referenceGroup si ya existe
		if (!val.referenceGroup) {
			val.referenceGroup = {};
		}
		const exist = this.evaluatorSelected.some(emp => emp.id === val.id);
		if (!exist) {
			this.evaluatorSelected.push(val);
		}
		if (Object.keys(val.referenceGroup).length === 0) {
			this.showNotification('Debes elegir un grupo de referencia para poder guardar', 'warning');
			this.$emit('btn-save', true);
		}
	} else {
		const index = this.evaluatorSelected.findIndex(d => d.id === val.id);
		if (index > -1) {
			this.evaluatorSelected.splice(index, 1);
		}
	}
	this.updateEmployeeEvaluators();
}

function selectReferencedGroup({ emplID, value }) {
	const findIndex = this.evaluatorSelected.findIndex(r => r.id === emplID);
	if (findIndex > -1) {
		this.evaluatorSelected[findIndex].referenceGroup = value;
		this.updateEmployeeEvaluators();
	}
}

function selectedAll(value) {
	this.employees = this.employees.map((r) => {
		const newRow = { ...r };
		newRow.isSelected = value;
		return newRow;
	});
	this.checkAll = value;

	if (value) {
		// Seleccionar todos: agregar empleados de esta página a evaluatorSelected
		this.employees.forEach((empl) => {
			const exist = this.evaluatorSelected.some(emp => emp.id === empl.id);
			if (!exist) {
				this.evaluatorSelected.push(empl);
			}
		});
	} else {
		// Deseleccionar todos: remover SOLO empleados de esta página
		const currentPageIds = new Set(this.employees.map(e => e.id));
		this.evaluatorSelected = this.evaluatorSelected.filter(emp => !currentPageIds.has(emp.id));
	}

	// Emitir evento para actualizar el botón de guardar
	const nullEG = this.evaluatorSelected
		.some(neo => !neo.referenceGroup || Object.keys(neo.referenceGroup).length === 0);
	if (this.evaluatorSelected.length > 0 && !nullEG) {
		this.updateEmployeeEvaluators();
	}
}

function filterRows(filter, value) {
	const filterString = filter.map((t) => {
		if (typeof t === 'object') {
			return t.id;
		}
		return t;
	});
	this.paramsGroup[value] = filterString.length ? filterString.join(',') : null;
	this.loadEmployees();
	this.selectedNames(filterString);
}

function openModalGroup() {
	this.openModal = true;
	this.title = 'Filtro';
	this.color = 'success';
}

function closeModal() {
	this.openModal = false;
	this.action = null;
}

function filterAreas() {
	this.loadEmployees();
	this.openModal = false;
}

function selectedNames(select) {
	this.formattedSelectedNames = select
		.map(groupId => this.groups.find(group => group.id === groupId).name);
}

function removeItem(item) {
	const removeName = this.formattedSelectedNames[item];
	const newFormattedSelectedNames = [...this.formattedSelectedNames];
	newFormattedSelectedNames.splice(item, 1);
	this.formattedSelectedNames = newFormattedSelectedNames;
	const groupObject = this.groups.find(group => group.name === removeName);
	if (groupObject) {
		const removeId = groupObject.id.toString();
		this.listIds = this.paramsGroup.groupIds.split(',');
		this.paramsGroup.groupIds = this.listIds.filter(id => id !== removeId).join(',') || null;
		this.loadEmployees();
	}
}

function updateEmployeeEvaluators() {
	const nullEG = this.evaluatorSelected
		.some(neo => !neo.referenceGroup || Object.keys(neo.referenceGroup).length === 0);
	const employee = this.employee;
	const evaluatorMap = this.evaluatorSelected.map(evalSel => ({
		id: evalSel.id,
		name: evalSel.name,
		lastName: evalSel.lastName,
		phoneNumber: evalSel.phoneNumber,
		job: evalSel.job,
		documentNumber: evalSel.documentNumber,
		group: evalSel.group,
		email: evalSel.email,
		isSelected: evalSel.isSelected,
		referenceGroup: evalSel.referenceGroup,
		groupId: evalSel.groupId,
		gender: evalSel.gender,
		asignedScore: 0.00,
		status: evalSel.status || 1,
		scoreEarned: 0.00,
		configAnswer: null,
	}));

	if (nullEG && this.evaluatorSelected.length > 0) {
		this.showNotification('Todos los evaluadores seleccionados deben tener un grupo de referencia', 'warning');
		this.$emit('btn-save', true);
	} else if (evaluatorMap.length === 0) {
		this.showGenericError('El empleado no puede quedarse sin Evaluadores.');
		this.$emit('btn-save', true);
	} else if (evaluatorMap.length > 0) {
		employee.evaluators.employees = evaluatorMap;
		this.$emit('btn-disable', false);
		this.$emit('btn-save', false);
		this.$emit('select-evaluator', { employee, index: this.indexEmployee });
	}
}

function indexEmployee(newValue, oldValue) {
	if (newValue !== oldValue) {
		this.evaluatorSelected = [];
		this.paramsGroup.groupIds = null;
		this.formattedSelectedNames = '';
		this.loadEmployees();
	}
}

function evaluatorSelected(newValue, oldValue) {
	if (newValue !== oldValue) {
		this.$emit('btn-disable', false);
	}
}

function changeColor(fieldName) {
	this.columns.forEach((c, index) => {
		if (c.fieldName !== fieldName && c.color) {
			this.$set(this.columns, index, { ...c, color: 'gray' });
		}
	});
}

function data() {
	return {
		employees: [],
		groups: [],
		evaluatorSelected: [],
		openModal: false,
		color: 'primary',
		action: null,
		paramsGroup: {
		},
		params: {
			page: 1,
			limit: 500,
		},
		lastPage: 0,
		totalItems: 0,
		currentPage: 1,
		listIds: [],
		formattedSelectedNames: '',
		columns: [
			{
				id: 1,
				name: 'Seleccionar Todos',
				value: 'name',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'name',
				color: 'gray',
			},
			{
				id: 2,
				name: '',
				visible: true,
				checked: true,
			},
		],
	};
}

export default {
	name: 'table-choose-evaluators',
	data,
	mounted,
	created,
	components: {
		InformationCard,
		buttonClear,
		modalAction,
	},
	methods: {
		rowIsSelected,
		selectedAll,
		loadEmployees,
		changePage,
		loadGroups,
		filterRows,
		openModalGroup,
		closeModal,
		filterAreas,
		selectedNames,
		removeItem,
		updateEmployeeEvaluators,
		selectReferencedGroup,
		onSearchEvent,
		changeSort,
		changeColor,
	},
	computed: {
		...mapState('evaluation360', {
			referenceGroups:
			pathOr(null, ['process', 'referenceGroups', 'references']),
			process:
			pathOr(null, ['process']),
			selectedEvaluators:
			pathOr(null, ['employeesAndEvaluators']),
		}),
	},
	props: {
		employee: {
			default: () => [],
			type: Object,
		},
		indexEmployee: Number,
		checkAll: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		indexEmployee,
		evaluatorSelected,

	},
};
</script>

<style lang="scss" scoped>
.nqt-container {
	display: flex;
	flex-direction: column;
	justify-content: space-bewteen;
	width: 100%;
	height: auto;
	border: 1px solid #E9E9E9;
	background-color: map-get($colors, white);
	border-radius: 8px;
	.nqt-container-title {
		font-size: size(xlarge);
		padding: 20px 30px;
	}
	.nqt-btn {
		align-items: center;
		display: flex;
		justify-content: center;
		gap: 10px;
		padding: 20px 30px;
	}

}
.form-process {
	bottom: 0;
	left: 0;
	padding: 0;
	position: relative !important;
	right: 0;

	&-input {
		background: map-get($colors, white);
		border: none;
		border-radius: 4px;
        display: block;
        outline: none;
		color: map-get($colors, secondary);
		margin-top: 4px;
		padding: 6px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
.tags-container {
	display: flex;
	flex-wrap: wrap;
	max-width: 100%;
	align-items: center;
	padding: 0 5px;
}
.tag {
	display: flex;
	align-items: center;
	border-radius: 5px;
	padding: 4px;
	margin: 2px;
}
.tag-content {
	display: inline-flex;
	align-items: center;
}
.tag v-icon {
	cursor: pointer;
	margin-left: 2px;
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/table-choose-evaluators.vue